export const webexStreamRegistry = {
  local: null as MediaStream | null,
  remote: new Map<string, MediaStream>(),
};
